import $$ from "cmn-utils";
import event from "./event";
import eventMongo from "./event-mongo";
import alarm from "./alarm";
import alarmMongo from "./alarm-mongo";
import actionLog from "./action";
import otherAction from "./otherAction";
import state from "./state";
import part from "./part";
import product from "./product";
import { formatData } from "@/utils/formatter";

const baseUrl = "/api/device/";
export default {
  action: (params) => {
    return $$.post(baseUrl + "send/action", params);
  },
  disRing: (params) => {
    return $$.post(baseUrl + "dis-ring", params);
  },
  changeState: (params) => {
    return $$.post(baseUrl + "change-state", params);
  },
  countDeviceState: (params) => {
    return $$.get(baseUrl + "count-device-state", params);
  },
  create: (params) => {
    let data = JSON.parse(JSON.stringify(params));
    Object.keys(data).map((key) => {
      if (
        data[key] === "null" ||
        data[key] === "undefined" ||
        data[key] === null ||
        data[key] === undefined
      )
        delete data[key];
    });
    return $$.post(baseUrl + "create", data);
  },
  delete: (params) => {
    return $$.post(baseUrl + "delete", params);
  },
  downloadResult: (params) => {
    return $$.get(baseUrl + "download-result", params);
  },
  exportExcel: (params) => {
    return $$.get(baseUrl + "export-excel", params);
  },
  get: function get(params) {
    return $$.get(baseUrl + "get", params);
  },
  handleAlarm: (params) => {
    return $$.post(baseUrl + "handle-alarm", params);
  },
  batchDeleteAlarm: (params) => {
    for (const key in params) {
      if (Object.hasOwnProperty.call(params, key)) {
        if (params[key] === undefined || params[key] === null) {
          delete params[key];
        }
      }
    }
    return $$.post(baseUrl + "batch-delete-alarm", params);
  },
  batchHandleAlarm: (params) => {
    for (const key in params) {
      if (Object.hasOwnProperty.call(params, key)) {
        if (params[key] === undefined || params[key] === null) {
          delete params[key];
        }
      }
    }
    return $$.post(baseUrl + "batch-handle-alarm", params);
  },
  importExcel: (data, formData) => {
    let url = baseUrl + "import-excel";
    if (data) {
      let paramsArray = [];
      //拼接参数
      Object.keys(data).forEach((key) =>
        paramsArray.push(key + "=" + data[key])
      );
      if (url.search(/\?/) === -1) {
        url += "?" + paramsArray.join("&");
      } else {
        url += "&" + paramsArray.join("&");
      }
    }
    return $$.post(url, formData, {
      headers: {
        "content-type": "multipart/form-data;boundary=" + new Date().getTime(),
        ...$$.getStore("headers"),
      },
    });
  },
  superImportExcel: (data, formData) => {
    let url = baseUrl + "super-import-excel";
    if (data) {
      let paramsArray = [];
      //拼接参数
      Object.keys(data).forEach((key) =>
        paramsArray.push(key + "=" + data[key])
      );
      if (url.search(/\?/) === -1) {
        url += "?" + paramsArray.join("&");
      } else {
        url += "&" + paramsArray.join("&");
      }
    }
    return $$.post(url, formData, {
      headers: {
        "content-type": "multipart/form-data;boundary=" + new Date().getTime(),
        ...$$.getStore("headers"),
      },
    });
  },
  list: (params) => {
    if (params) {
      formatData(params);
      if (params.startTime) {
        params.startTime = params.startTime.format("YYYY-MM-DD HH:mm:ss");
      }
      if (params.endTime) {
        params.endTime = params.endTime.format("YYYY-MM-DD HH:mm:ss");
      }
    }
    return $$.get(baseUrl + "list", params);
  },
  listMap: (params) => {
    formatData(params);
    return $$.get(baseUrl + "list-map", params);
  },
  update: (params) => {
    let data = JSON.parse(JSON.stringify(params));
    Object.keys(data).map((key) => {
      if (
        data[key] === "null" ||
        data[key] === "undefined" ||
        data[key] === null ||
        data[key] === undefined
      )
        delete data[key];
    });
    return $$.post(baseUrl + "update", data);
  },
  getActionBindProp: (params) => {
    return $$.get(baseUrl + "get-action-bind-prop", params);
  },
  getActionList: (params) => {
    return $$.get(baseUrl + "get-action-list", params);
  },
  getAction: (params) => {
    return $$.get(baseUrl + "get-action", params);
  },
  getEventList: (params) => {
    return $$.get(baseUrl + "get-event-list", params);
  },
  getLastActionParams: (params) => {
    return $$.get(baseUrl + "get-last-action-params", params);
  },
  replaceDevice: (params) => {
    return $$.post(baseUrl + "replace-device", params);
  },
  replaceUnit: (params) => {
    return $$.post(baseUrl + "replace-unit", params);
  },
  total: (params) => {
    return $$.get(baseUrl + "total", params);
  },
  event,
  eventMongo,
  alarm,
  alarmMongo,
  actionLog,
  otherAction,
  state,
  part,
  product,
};
